<template>
  <div class="autocomplete-container">
    <input class="form-control"
           v-model="internalQuery"
           @input="onInput"
           @focus="showSuggestions = true"
           @blur="onBlur"
           @keydown.down="moveDown"
           @keydown.up="moveUp"
           @keydown.enter="selectHighlighted"
           autocomplete="off"
           :placeholder="placeholder"
           v-capitalize />

    <ul v-if="showSuggestions && filteredItems.length"
        class="list-group position-absolute w-100 suggestion-list autocomplete-dropdown"
        style="z-index: 1000;"
        @mousedown.prevent>
      <li v-for="(item, index) in filteredItems" 
          :key="index"
          class="list-group-item list-group-item-action"
          :class="{ 'active': highlightedIndex === index }"
          @mousedown="selectItem(item)"
          @touchstart="selectItem(item)">
        {{ getItemLabel(item) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    labelField: {
      type: String,
      default: 'name'
    },
    valueField: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: 'Search...'
    },
    modelValue: { type: String, default: '' } 
  },
  data() {
    return {
      internalQuery:  this.modelValue,
      showSuggestions: false,
      highlightedIndex: -1
    };
  },
    watch: {
      modelValue(val) {
        this.internalQuery = val;
      }
    },
  computed: {
    filteredItems() {
      if (!this.internalQuery) return [];
      return this.items.filter(item =>
        item[this.labelField]?.toLowerCase().includes(this.internalQuery.toLowerCase())
      );
    }
  },
 
  methods: {
    onInput() {
      this.$emit('input-change', this.internalQuery);
      this.showSuggestions = true;
      this.highlightedIndex = -1;
    },
    onBlur() {
      // Only hide if not interacting with suggestions
      if (!this.interactingWithSuggestions) {
        setTimeout(() => {
          this.showSuggestions = false;
        }, 300);
      }
    },
     setFirmName(name) {
        this.internalQuery = name; // Set value programmatically
      },
    selectItem(item) {
      this.internalQuery = item[this.labelField];
      this.$emit('select', item);
      this.showSuggestions = false;
      this.interactingWithSuggestions = false;
    },
    getItemLabel(item) {
      return item[this.labelField];
    },
    moveDown() {
      if (this.highlightedIndex < this.filteredItems.length - 1) {
        this.highlightedIndex++;
      }
    },
    moveUp() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      }
    },
    selectHighlighted() {
      if (this.highlightedIndex >= 0) {
        this.selectItem(this.filteredItems[this.highlightedIndex]);
      }
    }
  }
};
</script>

<style scoped>
.autocomplete-container {
  position: relative;
}

.form-control {
  padding: 0.30rem 0.50rem;
  border: 1px solid #000000;
  font-weight: 600;
}

.autocomplete-dropdown {
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
}

.suggestion-list .list-group-item {
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.suggestion-list .list-group-item:hover,
.suggestion-list .list-group-item.active {
  background-color: #f1f1f1;
}

/* Tablet-specific styles */
@media (hover: none) and (pointer: coarse) {
  .form-control {
    font-size: 18px;
    padding: 12px;
    min-height: 48px; /* Better touch target */
  }

  .suggestion-list .list-group-item {
    padding: 16px;
    font-size: 17px;
    min-height: 48px; /* Better touch target */
  }
  
  .autocomplete-dropdown {
    /* More visible on tablets */
    border: 1px solid #ddd;
    border-top: none;
  }
}
</style>